/**
 * @generated SignedSource<<6f34964068824d95db5fe8ac203f6030>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserSnippet_user",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Avatar_iHaveAvatar"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserNameLabel_user"
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
};
node.hash = "211ac2fc60778d3f6187535b464eca21";
export default node;
